import { render, staticRenderFns } from "./MoonwalkerIcon.vue?vue&type=template&id=0af5a882&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5a882')) {
      api.createRecord('0af5a882', component.options)
    } else {
      api.reload('0af5a882', component.options)
    }
    module.hot.accept("./MoonwalkerIcon.vue?vue&type=template&id=0af5a882&", function () {
      api.rerender('0af5a882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/MoonwalkerIcon.vue"
export default component.exports